import { SignUpPage } from '@ppay/client'
import React from 'react'

import { routes } from '../../router'
import { CredentialsForm } from './CredentialsForm'

export function Page() {
  return (
    <SignUpPage
      credentialsForm={CredentialsForm}
      successPath={routes.auth.login}
      termsOfUseUrl={process.env.REACT_APP_TERMS_URL!}
      privacyPolicyUrl={process.env.REACT_APP_PRIVACY_URL!}
    />
  )
}
